// @flow
import React, { Component } from "react";
import "./styles.css";

type PropsType = {
    message?: string,
    containerStyle?: Object
};

export const Spinner = ({ message, containerStyle = {} }: PropsType) => (
    <div className={ "spinner" } style={ containerStyle }>
        <div className={ "spinner--container" }>
            <div className="spinner--animation">
                <div id="spinner" className="petaloso-spinner">
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="petal"/>
                    <div className="pistil"/>
                </div>
            </div>
            {Boolean(message) &&
                <div className={ "spinner--message" }>{message}</div>}
        </div>
    </div>
);
